module.exports = __webpack_public_path__ + "static/soundcloud-1ac51f3f9cdc3c9bc839d8b98d1cce90.png";